interface Iprops {
  width: number;
  height: number;
}

export const MenuIcon = ({ width, height }: Iprops) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5401 9.06014C15.7701 9.06014 14.3301 7.62014 14.3301 5.85014C14.3301 4.08014 15.7701 2.64014 17.5401 2.64014C19.3101 2.64014 20.7501 4.08014 20.7501 5.85014C20.7501 7.62014 19.3101 9.06014 17.5401 9.06014ZM17.5401 4.13014C16.6001 4.13014 15.8301 4.90014 15.8301 5.84014C15.8301 6.78014 16.6001 7.55014 17.5401 7.55014C18.4801 7.55014 19.2501 6.78014 19.2501 5.84014C19.2501 4.90014 18.4801 4.13014 17.5401 4.13014Z"
        fill="#8B95A6"
      />
      <path
        d="M6.46001 9.06014C4.69001 9.06014 3.25 7.62014 3.25 5.85014C3.25 4.08014 4.69001 2.64014 6.46001 2.64014C8.23001 2.64014 9.67 4.08014 9.67 5.85014C9.67 7.62014 8.23001 9.06014 6.46001 9.06014ZM6.46001 4.13014C5.52001 4.13014 4.75 4.90014 4.75 5.84014C4.75 6.78014 5.52001 7.55014 6.46001 7.55014C7.40001 7.55014 8.17 6.78014 8.17 5.84014C8.17 4.90014 7.41001 4.13014 6.46001 4.13014Z"
        fill="#8B95A6"
      />
      <path
        d="M17.5401 21.37C15.7701 21.37 14.3301 19.93 14.3301 18.16C14.3301 16.39 15.7701 14.95 17.5401 14.95C19.3101 14.95 20.7501 16.39 20.7501 18.16C20.7501 19.93 19.3101 21.37 17.5401 21.37ZM17.5401 16.44C16.6001 16.44 15.8301 17.21 15.8301 18.15C15.8301 19.09 16.6001 19.86 17.5401 19.86C18.4801 19.86 19.2501 19.09 19.2501 18.15C19.2501 17.21 18.4801 16.44 17.5401 16.44Z"
        fill="#8B95A6"
      />
      <path
        d="M6.46001 21.37C4.69001 21.37 3.25 19.93 3.25 18.16C3.25 16.39 4.69001 14.95 6.46001 14.95C8.23001 14.95 9.67 16.39 9.67 18.16C9.67 19.93 8.23001 21.37 6.46001 21.37ZM6.46001 16.44C5.52001 16.44 4.75 17.21 4.75 18.15C4.75 19.09 5.52001 19.86 6.46001 19.86C7.40001 19.86 8.17 19.09 8.17 18.15C8.17 17.21 7.41001 16.44 6.46001 16.44Z"
        fill="#8B95A6"
      />
    </svg>
  );
};
